import { Injectable, inject, Injector } from "@angular/core";
import { getWkDataTableColumnRegistry, getWkDataTableRowRegistry } from "./data-table.tokens";
import { WkDataTableSimpleColumn } from "./columns";
import { WkDataTableRow } from "./rows";
import type { WkDataTableColumnRegistration, WkDataTableRowRegistration } from "./data-table.types";

@Injectable()
export abstract class WkDataTableRegistrationResolver<TColumn extends WkDataTableColumnRegistration, TRow extends WkDataTableRowRegistration> {
    protected readonly injector = inject(Injector);
    protected readonly columnRegistrations = inject(getWkDataTableColumnRegistry<TColumn>(), { optional: true }) ?? [];
    protected readonly rowRegistrations = inject(getWkDataTableRowRegistry<TRow>(), { optional: true }) ?? [];

    public abstract getColumns(): WkDataTableSimpleColumn<any, any>[];
    public abstract getRow(): WkDataTableRow<any>;
}
